<template>
    <div>
        <div class="col-12 mb-4 d-flex justify-content-between align-items-baseline">
            <h4>Warehouses</h4>
            <button @click="newWarehouse" :disabled="loading" class="btn btn-primary">
                New warehouse
            </button>
        </div>
        <AppTable
            :columns="columns"
            :query="query"
            :rows="warehouses"
            @on-row-click="viewWarehouse"
            :loading="loading"
            :total="total"
            @on-query-change="onQueryChange"
        />
    </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import AppTable from '../form/AppTable';

export default {
  components: {
    AppTable,
  },
  computed: {
    ...mapGetters({
      warehouses: 'warehouses/warehouses',
    }),
    ...mapState({
      query: (state) => state.warehouses.query,
      total: (state) => state.warehouses.totalWarehouses,
    }),
    columns() {
      return [
        {
          label: 'Name',
          field: 'name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Country',
          field: 'location.country.name',
          filterOptions: {
            enabled: true,
          },
        },
        {
          label: 'Region',
          field: 'location.region.name',
          filterOptions: {
            enabled: true,
          },
        },
      ];
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  mounted() {
    this.getWarehouses();
  },
  methods: {
    newWarehouse() {
      this.$router.push({
        name: 'warehouse',
        params: { id: 'new' },
      });
    },
    getWarehouses() {
      this.loading = true;

      this.$store.dispatch('warehouses/getWarehouses').finally(() => {
        this.loading = false;
      });
    },
    viewWarehouse(event) {
      this.$router.push({
        name: 'warehouse',
        params: { id: event.row.id },
      });
    },
    onQueryChange(props) {
      this.$store.commit('warehouses/queryProps', props);
      this.getWarehouses();
    },
  },
};
</script>
